import { createSlice } from '@reduxjs/toolkit'

const entityIdsSlice = createSlice({
	name: 'entityIds',
	initialState: {
		artist: [],
		owner: [],
		artwork: [],
	},
	reducers: {
		setArtistIds(state, action) {
			state.artist = action.payload ?? []
		},
		setOwnerIds(state, action) {
			state.owner = action.payload ?? []
		},
		setArtworkIds(state, action) {
			state.artwork = action.payload ?? []
		},
	},
})

export const { setArtistIds, setOwnerIds, setArtworkIds } =
	entityIdsSlice.actions
export default entityIdsSlice.reducer
